export const focusingScroll = (elem: HTMLElement | null, offset: number) => {
  const top = elem?.getBoundingClientRect().top ?? 0;
  window.scrollTo({
    top: top + window.scrollY - offset,
    behavior: "smooth",
  });
};
